import { RuleObject } from 'antd/lib/form';
import TranslateText from 'components/hoc/TranslateText';
import { emailRegExp } from 'enums/regExp';
import React from 'react';

export const emailValidation = (rulesMessage: string) => [
    {
        required: true,
        message: <TranslateText>{rulesMessage}</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || emailRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL</TranslateText>);
        }
    })
];

export default emailValidation;
